import { render, staticRenderFns } from "./ActivityValuesCreateEdit.vue?vue&type=template&id=64e1e88b"
import script from "./ActivityValuesCreateEdit.vue?vue&type=script&lang=js"
export * from "./ActivityValuesCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports